import { X } from "lucide-react";
import BenitoAvatar from "../BenitoAvatar";
import Button from "../foundational/Button";
import { CURSOS } from "../../lib/cursoPaliativos";

// La pieza de un curso con QR (13-oct-2026 para cuidados paliativos, desde el
// 15-oct también accesos vasculares; ver CURSOS en lib/cursoPaliativos.js).
// Recibe el curso; sin él muestra el primero, el de paliativos. Dos caras con
// el mismo caso:
// - Sin sesión (BienvenidaCurso), arriba de la portada: muestra el caso y la
//   pregunta y lleva a la tarjeta de acceso. Benito pide cuenta.
// - Con sesión (CasoCursoCard), en el inicio: el botón deja la pregunta
//   escrita en el panel de Benito y la persona decide cuándo enviarla.

function CasoYPregunta({ curso }) {
  return (
    <div className="mt-4 space-y-3 text-left">
      <div className="rounded-tk-md border border-edge bg-paper p-3">
        <p className="text-micro font-semibold text-ink-subtle dark:text-ink-muted">Caso ficticio</p>
        <p className="mt-1 text-small leading-relaxed text-ink">{curso.caso}</p>
      </div>
      <div className="flex items-start gap-2.5">
        <BenitoAvatar size={28} className="mt-0.5 flex-shrink-0" />
        <div className="min-w-0 rounded-tk-md border border-accent-border bg-accent-bg/40 p-3">
          <p className="text-micro font-semibold text-ink-subtle dark:text-ink-muted">La pregunta para Benito</p>
          <p className="mt-1 text-small leading-relaxed text-ink">{curso.pregunta}</p>
        </div>
      </div>
    </div>
  );
}

export function BienvenidaCurso({ onIrAAcceso, curso = CURSOS[0] }) {
  return (
    <section
      aria-labelledby="curso-titulo"
      className="mx-auto w-full max-w-[32rem] px-5 pt-8 font-sans"
    >
      <div className="rounded-tk-lg border border-edge bg-surface p-5 shadow-tk-sm">
        <p className="text-small font-medium text-accent">¿Vienes del curso de {curso.nombre}?</p>
        <h2 id="curso-titulo" className="mt-1 text-h2 font-semibold text-ink">
          Trabaja el mismo caso con Benito
        </h2>
        <CasoYPregunta curso={curso} />
        <p className="mt-4 text-small leading-relaxed text-ink-subtle dark:text-ink-muted">
          Crea tu cuenta gratis o entra. En tu inicio te espera la pregunta lista para enviársela a Benito.
        </p>
        <Button variant="primary" size="lg" onClick={onIrAAcceso} className="mt-4 w-full min-h-[44px]">
          Quiero preguntarle a Benito
        </Button>
      </div>
    </section>
  );
}

export function CasoCursoCard({ onPreguntar, onCerrar, className = "", curso = CURSOS[0] }) {
  return (
    <section
      aria-labelledby="curso-card-titulo"
      className={`rounded-tk-lg border border-edge bg-surface p-4 shadow-tk-sm ${className}`}
    >
      <div className="flex items-start gap-2">
        <div className="min-w-0 flex-1">
          <p className="text-small font-medium text-accent">Del curso de {curso.nombre}</p>
          <h2 id="curso-card-titulo" className="mt-1 text-h3 font-semibold text-ink">
            Trabaja el caso con Benito
          </h2>
        </div>
        <button
          type="button"
          onClick={onCerrar}
          aria-label="Cerrar el caso del curso"
          className="-mr-2 -mt-2 flex h-[44px] w-[44px] flex-shrink-0 items-center justify-center rounded-tk-sm text-ink-muted hover:bg-paper hover:text-ink transition-colors"
        >
          <X size={18} strokeWidth={2} />
        </button>
      </div>
      <CasoYPregunta curso={curso} />
      <Button variant="primary" size="lg" onClick={() => onPreguntar(curso.pregunta)} className="mt-4 w-full min-h-[44px]">
        Pregúntale a Benito
      </Button>
      <p className="mt-2 text-center text-micro text-ink-subtle dark:text-ink-muted">
        La pregunta queda escrita y tú decides cuándo enviarla.
      </p>
    </section>
  );
}
